import { render } from "./DocumentsTable.vue?vue&type=template&id=2502783a"
import script from "./DocumentsTable.vue?vue&type=script&lang=js"
export * from "./DocumentsTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__